// extracted by mini-css-extract-plugin
module.exports = {"content--empty":"content--empty__1GaVF"};